import apiKit from "./apiKit";

export const createCustomer = async (body) => {
  try {
    const url = `customer`;
    const res = await apiKit.post(url, body);
    console.log("customer creation", res);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const createCustomerOnDB = async (body, create = false) => {
  try {
    let id = null;

    if (!create) {
      const storedId = await localStorage.getItem("customer_id");
      if (storedId && storedId !== "null" && storedId !== "undefined") {
        id = storedId;
      }
    }
    let res = {}
    let url = "customer/create";
    if (id) {
      url = `customer/update/${id}`;;
      res = await apiKit.put(url, body);
    } else {
      res = await apiKit.post(url, body);
    }


    // Save ID if it's newly returned
    if (create && res.data?.result?.id) {
      localStorage.setItem("customer_id", res.data.result.id);
    }

    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};


export const getMarketingPartners = async () => {
  try {
    const url = `marketPartner`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
